import { render } from "./claim-detail-card.vue?vue&type=template&id=268d3792&scoped=true&ts=true"
import script from "./claim-detail-card.vue?vue&type=script&lang=ts"
export * from "./claim-detail-card.vue?vue&type=script&lang=ts"

import "./claim-detail-card.vue?vue&type=style&index=0&id=268d3792&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268d3792"]])

export default __exports__